import { render, staticRenderFns } from "./brand_view.vue?vue&type=template&id=4c7c4d6f&scoped=true&"
import script from "./brand_view.vue?vue&type=script&lang=ts&"
export * from "./brand_view.vue?vue&type=script&lang=ts&"
import style0 from "./brand_view.vue?vue&type=style&index=0&id=4c7c4d6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c4d6f",
  null
  
)

export default component.exports